import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import logo from '../../assets/logo.svg';
import CommuniCaptures from '../../components/CommuniCaptures';

const CommuniCaptureList = () => {

  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);



  return (
    
      <div>
        
            <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Task List</h3>
            <CommuniCaptures />

      </div>

  )
}

export default CommuniCaptureList